enum LoggerTypes {
    EXCEPTION = 'exception',
    PAGE_VIEW = 'pageView',
    TRACE = 'trace',
    EVENT = 'event',
    REMOTE_LOADED = 'remoteLoaded',
    FEATURE_FLAG = 'featureflag',
}

export default LoggerTypes;
